module.exports = __webpack_public_path__ + "static/02-041db7c76cc83b3db8b8a78224eb6361.png";